import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/documentsTypes.constants';
import { getAll, getOne, save, softDelete } from 'services/documentsTypes.services';

export function* documentsTypesDelete(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.DOCUMENTS_TYPES_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.DOCUMENTS_TYPES_ON_DELETE_FAILED, error });
  }
}

export function* documentsTypesGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({ type: constants.DOCUMENTS_TYPES_ON_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DOCUMENTS_TYPES_ON_GET_ALL_FAILED, error });
  }
}

export function* documentsTypesGetOne(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.DOCUMENTS_TYPES_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.DOCUMENTS_TYPES_ON_GET_ONE_FAILED, error });
  }
}

export function* documentsTypesSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.DOCUMENTS_TYPES_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DOCUMENTS_TYPES_ON_SAVE_FAILED, error });
  }
}

export function* documentsTypesRefresh(): Generator {
  const table: any = yield select((state) => state.documentsTypes.table);
  yield put({ type: constants.DOCUMENTS_TYPES_ON_GET_ALL_REQUESTED, ...table });
}

export function* watchDocumentsTypes(): Generator {
  yield all([
    takeLatest(constants.DOCUMENTS_TYPES_ON_DELETE_REQUESTED, documentsTypesDelete),
    takeLatest(constants.DOCUMENTS_TYPES_ON_GET_ALL_REQUESTED, documentsTypesGetAll),
    takeLatest(constants.DOCUMENTS_TYPES_ON_GET_ONE_REQUESTED, documentsTypesGetOne),
    takeLatest(constants.DOCUMENTS_TYPES_ON_SAVE_REQUESTED, documentsTypesSave),
    takeLatest(
      [constants.DOCUMENTS_TYPES_ON_DELETE_SUCCEEDED, constants.DOCUMENTS_TYPES_ON_SAVE_SUCCEEDED],
      documentsTypesRefresh,
    ),
  ]);
}
